// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ament","colMin":"styles_colMin__1yr3D"};